import e from "./SchemaObjectProperties.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/SchemaObjectProperties.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaObjectProperties.vue.js.map